import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { io } from 'socket.io-client';
import ConnUrls from '../../../../MyConns/Connections/ConnectURL';
import utilsOrders from '../../../../MyConns/_Utils/utilsOrders';
// import OrderFunctions from '../../../../MyFunctions/OrderFunctions';
import myFunctions from '../../../../myFunctions';
import { ScreenWidthContext } from '../../../MyContexts/ScreenWidth_Context';
import MySpinner_Wait from '../../../MySections/DTechComps/MySpinner_Wait';
import MyDateTime from '../../../MySections/TimeSections/MyDateTime';
import Breadcrumb from './Breadcrumb';
import BuisTollBar from './BuisTollBar';
import BuisTollBarMobi from './BuisTollBarMobi';
import ListOrdersBlocks from './ListOrdersBlocks';
import ListOrdersTable from './ListOrdersTable';



const OrderLst = (props) => {

    const history = useHistory();
    const [screenWidth, setScreenWidth] = useContext(ScreenWidthContext);
    const [userBuis, setUserBuis] = useState();
    const [orderlisttable, setOrderlisttable] = useState([]);
    // const [srchList, setSrchList] = useState([]);
    // const [allCats, setAllCats] = useState([]);
    const [thePopUp, setThePopUp] = useState("");
    const [srchText, setSrchText] = useState("");
    const [startDTS, setStartDTS] = useState();
    const [endDTS, setEndDTS] = useState();
    const [totOfAll, setTotOfAll] = useState(0);
    const [showBetweenDts, setShowBetweenDts] = useState(false);
    // const [beepMe, setBeepMe] = useState();
    const [lstCounter, setLstCounter] = useState(null);
    const [selectedBtn, setSelectedBtn] = useState(5);
    const [listSordted, setListSordted] = useState({ sort: false, sortBy: "Asc" });
    const [intervalID, setIntervalID] = useState(null);
    const [loading, setLoading] = useState(false);
    const [srchText1, setSrchText1] = useState("");
    const [srchText2, setSrchText2] = useState("");
    // const [busissList, setBusissList] = useState([]);

    let allIntervs = [];

    useEffect(() => {
        myFunctions.connCheck();
    })

    useEffect(() => {
        stopHandler();

        const socket = io.connect(ConnUrls.socketClient, {
            auth: {
                token: localStorage.getItem("token")
            },
            query: {
                userType: "back"
            }
        }
        );

        socket.on("orderUpdated", (data) => {
            let selBtn = sessionStorage.getItem("ordLstBtn");

            if (selBtn != null) {
                refreshTheList(selBtn)
            }
            else {
                refreshTheList(selectedBtn)
            }

        })

        socket.on("newOrder", (data) => {

            setTimeout(() => {
                let selBtn = sessionStorage.getItem("ordLstBtn");
                if (selBtn != null) {

                    refreshTheList(selBtn)

                }
                else {

                    refreshTheList(selectedBtn)
                }
                myFunctions.hearBling();

            }, 5000);

        })



    }, [ConnUrls.socket])


    useEffect(() => {

        refreshTheList(selectedBtn);
    }, [])


    const startHandler = (OrdrsList) => {

        if (intervalID != null) {
            clearInterval(intervalID)
        }

        setIntervalID(setInterval(() => {
            OrdrsList.map((item, i) => {

                let theId = i + "_Cnt";
                var theELEMENT = window.document.getElementById(theId);
                if (theELEMENT) {
                    if (item.orderStatus != "סגור" && item.orderStatus != "מושהה" && item.orderStatus != "מבוטל") {
                        let theItm = MyDateTime.getTimeLeftTilThen(item.dateToDeliver, item.OrderTimes);
                        theELEMENT.innerText = theItm.theTm
                        theELEMENT.style.backgroundColor = theItm.theCol
                        theELEMENT.style.color = theItm.theForCol
                        theELEMENT.style.fontWeight = "bold"
                        theELEMENT.style.paddingRight = "5px"
                    }
                    else {
                        theELEMENT.innerText = ""
                    }
                }

            });
        }, 1000))

    }
    const stopHandler = () => {
        // clearInterval(intervalID)

        var highestTimeoutId = setInterval(";");

        for (var i = 0; i < highestTimeoutId; i++) {
            clearInterval(i);
        }
    }

    const getTimes = (OrdrsList) => {

        stopHandler()
        startHandler(OrdrsList)
    }

    const showAllOrders = async (btnInt) => {

        let OrdrsList = await utilsOrders.getAllOrders(startDTS, endDTS);
        setOrderlisttable(OrdrsList);
        getTheTotal(OrdrsList)
        setSrchText("");
        getTimes(OrdrsList)
        setSelectedBtn(btnInt)

    }


    const showByType = async (typ, btnInt) => {

        let OrdrsList = await utilsOrders.getOrdByType(typ);

        setOrderlisttable(OrdrsList);
        getTheTotal(OrdrsList)
        setSrchText("")

        getTimes(OrdrsList)

        setSelectedBtn(btnInt)

    }


    const refreshTheList = (btnInt) => {
        const action = buttonActions[btnInt.toString()];
        if (action) {
            action();
        }
    };
    const buttonActions = {
        "5": () => waitingToApprove(5),
        "6": () => showTodaysOpen(6),
        "7": () => showTodaysAll(7),
        "8": () => showYesterdayAll(8),
        // "9": () => showMounth(9),
        "10": () => {
            setShowBetweenDts(!showBetweenDts);
            setSelectedBtn(10);
        },
        "11": () => showByDates(10),
        "12": () => showAllOpen(12)
    };



    //ממתינות לאישור
    const waitingToApprove = async (btnInt) => {
        let OrdrsList = await utilsOrders.getWaitingApproveOrders();
        setAllLists(btnInt, OrdrsList);
    }


    //להיום ומחר
    const showTodaysOpen = async (btnInt) => {


        var tempToday = MyDateTime.getSpecificDate(new Date(), 0);
        var today = MyDateTime.setTimeByStr(tempToday, { hh: "05", mm: "00", ss: "00" })

        var tempTommorow = MyDateTime.getSpecificDate(new Date(), 1);
        var tommorow = MyDateTime.setTimeByStr(tempTommorow, { hh: "23", mm: "59", ss: "59" })
        setStartDTS(today);
        setEndDTS(tommorow);


        let OrdrsList = await utilsOrders.getOpenOrders(today, tommorow);

        OrdrsList = myFunctions.getListByBuisId(OrdrsList, userBuis);

        setAllLists(btnInt, OrdrsList);

    }

    //כל הפתוחות
    const showAllOpen = async (btnInt) => {

        let OrdrsList = await utilsOrders.getOpenOrders();
        // OrdrsList = myFunctions.getListByBuisId(OrdrsList, userBuis);
        setAllLists(btnInt, OrdrsList);

    }


    //עד סוף השבוע
    const showTodaysAll = async (btnInt) => {
        var tempToday = MyDateTime.getSpecificDate(new Date(), 0);
        var today = MyDateTime.setTimeByStr(tempToday, { hh: "05", mm: "00", ss: "00" })

        var tempNextSaturday = MyDateTime.getNextSaturday(new Date());
        var nextSaturday = MyDateTime.setTimeByStr(tempNextSaturday, { hh: "23", mm: "59", ss: "59" })
        setStartDTS(today);
        setEndDTS(nextSaturday);


        let OrdrsList = await utilsOrders.getOpenOrders(today, nextSaturday);

        OrdrsList = myFunctions.getListByBuisId(OrdrsList, userBuis);

        setAllLists(btnInt, OrdrsList);



        // var today = MyDateTime.getSpecificDate(new Date(), 0);
        // var yesterday = MyDateTime.setTimeByStr(today, { hh: "05", mm: "00", ss: "00" })

        // setStartDTS(today);
        // setEndDTS(yesterday);


        // let OrdrsList = await utilsOrders.getAllOrders(yesterday, today);
        // console.log(OrdrsList);

        // setAllLists(btnInt, OrdrsList);

    }



    //עד סוף החודש
    const showYesterdayAll = async (btnInt) => {
        var tempToday = MyDateTime.getSpecificDate(new Date(), 0);
        var today = MyDateTime.setTimeByStr(tempToday, { hh: "05", mm: "00", ss: "00" })

        var tempEndOfMonth = MyDateTime.getEndOfMonth(new Date());
        var endOfMonth = MyDateTime.setTimeByStr(tempEndOfMonth, { hh: "23", mm: "59", ss: "59" })
        setStartDTS(today);
        setEndDTS(endOfMonth);


        let OrdrsList = await utilsOrders.getOpenOrders(today, endOfMonth);

        OrdrsList = myFunctions.getListByBuisId(OrdrsList, userBuis);

        setAllLists(btnInt, OrdrsList);





        // var day1 = MyDateTime.getSpecificDate(new Date(), -1);
        // day1 = MyDateTime.setTimeByStr(day1, { hh: "05", mm: "00", ss: "00" })

        // var day2 = MyDateTime.getSpecificDate(day1, 1);
        // var day2 = MyDateTime.setTimeByStr(day2, { hh: "05", mm: "00", ss: "00" })

        // setStartDTS(day1);
        // setEndDTS(day2);

        // let OrdrsList = await utilsOrders.getAllOrders(day1, day2);
        // setAllLists(btnInt, OrdrsList);

    }

    // //מתחילת החודש
    // const showMounth = async (btnInt) => {

    //     var day1 = MyDateTime.getSpecificDate(new Date(), 0);

    //     var day2 = MyDateTime.getFirstDayinMounth(day1);
    //     var startOfMounth = MyDateTime.setTimeByStr(day2, { hh: "00", mm: "00", ss: "00" })

    //     setStartDTS(startOfMounth);
    //     setEndDTS(day1);
    //     console.log(startOfMounth);
    //     console.log(day1);

    //     let OrdrsList = await utilsOrders.getAllOrders(day2, day1);
    //     setAllLists(btnInt, OrdrsList);
    // }

    //לפי תאריכים
    const showByDates = async (btnInt) => {

        var day1 = MyDateTime.getSpecificDate(startDTS);
        var day2 = MyDateTime.getSpecificDate(endDTS);

        setStartDTS(day1);
        setEndDTS(day2);

        let OrdrsList = await utilsOrders.getAllOrders(day1,day2 );

        // let OrdrsList = await utilsOrders.getAllOrders(endDTS, startDTS);
        setAllLists(btnInt, OrdrsList);
    }

    const setAllLists = (btnInt, OrdrsList) => {

        getTimes(OrdrsList)
        setLstCounter(OrdrsList.length)
        setOrderlisttable(OrdrsList);
        getTheTotal(OrdrsList)
        setSrchText("");
        setSelectedBtn(btnInt)
        sessionStorage.setItem("ordLstBtn", btnInt)

        setShowBetweenDts(false)
    }

    const showOpenOrders = async (btnInt) => {

        let OrdrsList = await utilsOrders.getOpenOrders(endDTS, startDTS);

        setAllLists(btnInt, OrdrsList);

    }


    const showClosedOrders = async (btnInt) => {

        let OrdrsList = await utilsOrders.getClosedOrders(endDTS, startDTS);

        setAllLists(btnInt, OrdrsList);

    }

    const setNewStatus = async (orderId, statBack, buisId) => {
        let updteme = await utilsOrders.updateStatus(orderId, statBack);

        let temp = orderlisttable.findIndex(it => it._id == orderId);
        orderlisttable[temp].orderStatus = statBack;

        setAllLists(selectedBtn, orderlisttable);

        // socket.emit('orderUpdated', { buisId });

    }


    const rowCellClick = (ordId) => {
        stopHandler();
        history.push('/Order/' + ordId);
    }

    const checkIfEnter = (e,byWhat) => {
        if (e.key === 'Enter') {
            searchOrder(byWhat);
        }
    }

    const searchOrder = async (byWhat) => {
        setLoading(true)

        let txt = (byWhat === "byAll") ? srchText2 : (byWhat === "orderNUM") ? srchText1 : "";
        let OrdrsBk = await utilsOrders.getOrderBySearch(txt, startDTS, endDTS, byWhat);
        if (OrdrsBk != null && OrdrsBk.errMsg !== 'error') {
            setOrderlisttable(OrdrsBk);
            getTheTotal(OrdrsBk)
            getTimes(OrdrsBk)
        }
        setLoading(false)

    }

    const getTheTotal = (OrdrsBk) => {
        let totAll = 0;
        OrdrsBk.forEach(element => {
            totAll += parseFloat(element.totalPrice);
        });

        setTotOfAll(totAll)
    }


    const orderBythis = (byWhat, ordUserOrBuiss) => {
        if (listSordted.sortBy == "Asc") {
            setOrderlisttable(myFunctions.sortByItemAsc(orderlisttable, byWhat, ordUserOrBuiss))
            setAllLists(selectedBtn, myFunctions.sortByItemAsc(orderlisttable, byWhat, ordUserOrBuiss));
            setListSordted({ sort: true, sortBy: "Dsc" })
        }
        else {
            setOrderlisttable(myFunctions.sortByItemDsc(orderlisttable, byWhat, ordUserOrBuiss))
            setAllLists(selectedBtn, myFunctions.sortByItemDsc(orderlisttable, byWhat, ordUserOrBuiss));
            setListSordted({ sort: true, sortBy: "Asc" })
        }


    }

    // let theList = listSordted
    let theList = (!listSordted.sort && orderlisttable) ?
        (myFunctions.sortByItemDsc(orderlisttable, "dateToDeliver", "ord")) : orderlisttable;

    return (
        <>

            <div className="ms-content-wrapper">
                <div className="ordrspanel">
                    <Breadcrumb />
                    {/* Active Orders Graph */}
                    <div className="ordrspanel">
                        <div className="ms-panel">
                            {screenWidth > 800 ?
                                <BuisTollBar
                                    selectedBtn={selectedBtn}
                                    refreshTheList={(selectedBtn) => refreshTheList(selectedBtn)}
                                    srchText={srchText}
                                    srchText1={srchText1}
                                    srchText2={srchText2}
                                    setSrchText1={(txt) => setSrchText1(txt)}
                                    setSrchText2={(txt) => setSrchText2(txt)}
                                    searchOrder={(txt) => searchOrder(txt)}
                                    showBetweenDts={showBetweenDts}
                                    setShowBetweenDts={(btdats) => setShowBetweenDts(btdats)}
                                    showAllOpen={(indx) => showAllOpen(indx)}
                                    startDTS={startDTS}
                                    setStartDTS={(dt) => setStartDTS(dt)}
                                    endDTS={endDTS}
                                    setEndDTS={(dt) => setEndDTS(dt)}
                                    checkIfEnter={(e,byWhat) => checkIfEnter(e,byWhat)}
                                    setUserBuis={(newVal) => { setUserBuis(newVal) }}
                                />
                                :
                                <BuisTollBarMobi
                                    selectedBtn={selectedBtn}
                                    refreshTheList={(selectedBtn) => refreshTheList(selectedBtn)}
                                    srchText1={srchText1}
                                    srchText2={srchText2}
                                    setSrchText1={(txt) => setSrchText1(txt)}
                                    setSrchText2={(txt) => setSrchText2(txt)}
                                    searchOrder={(txt) => searchOrder(txt)}
                                    showBetweenDts={showBetweenDts}
                                    setShowBetweenDts={(btdats) => setShowBetweenDts(btdats)}
                                    showAllOpen={(indx) => showAllOpen(indx)}
                                    startDTS={startDTS}
                                    setStartDTS={(dt) => setStartDTS(dt)}
                                    endDTS={endDTS}
                                    setEndDTS={(dt) => setEndDTS(dt)}
                                    checkIfEnter={(e,byWhat) => checkIfEnter(e,byWhat)}
                                />
                            }


                            {loading ?
                                <MySpinner_Wait />
                                :
                                <div className="fullRow">
                                    <div className="col-md-12">

                                        {screenWidth > 500 ?
                                            <>
                                                <div className={"totalsLine"}>
                                                    <div className={"onLeft spaceMargeRightbig"}>סה"כ: {totOfAll} ₪</div>
                                                    <div className={"onLeft "}>משלוחים: {orderlisttable.length}</div>
                                                </div>
                                                <ListOrdersTable
                                                    theList={theList}
                                                    orderBythis={(byWhat, ordUserOrBuiss) => orderBythis(byWhat, ordUserOrBuiss)}
                                                    rowCellClick={(ordId) => rowCellClick(ordId)}
                                                    setNewStatus={(orderId, statBack, buisId) => setNewStatus(orderId, statBack, buisId)}
                                                />
                                            </>
                                            :
                                            <>
                                                <div className={"totalsLine"}>
                                                    <div className={"onRight spaceMargeLeftbig"}>משלוחים: {orderlisttable.length}</div>
                                                    <div className={"onRight "}>סה"כ: {totOfAll} ₪</div>
                                                </div>
                                                <ListOrdersBlocks
                                                    theList={theList}
                                                    orderBythis={(byWhat, ordUserOrBuiss) => orderBythis(byWhat, ordUserOrBuiss)}
                                                    rowCellClick={(ordId) => rowCellClick(ordId)}
                                                    setNewStatus={(orderId, statBack, buisId) => setNewStatus(orderId, statBack, buisId)}
                                                />
                                            </>

                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {thePopUp}

            </div >

        </>
    );


}

export default OrderLst;

